<template>
  <div
    :class="[
      'border rounded-lg p-4 h-full max-h-screen flex flex-col transition-all',
      isFocused ? 'ring-2 ring-indigo-500' : ''
    ]"
    ref="container"
  >
    <h4 class="font-semibold mb-2 shrink-0">Users</h4>

    <ul class="overflow-y-auto flex-1 min-h-0">
      <li
        v-for="u in users"
        :key="u.id"
        :ref="`user-${u.id}`"
        @click="$emit('select', u.id)"
        :class="[
          'cursor-pointer p-1',
          selected === u.id ? 'bg-indigo-100' : ''
        ]"
      >
        {{ u.first_name }} {{ u.last_name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    users: Array,
    selected: Number,
    isFocused: Boolean
  },
  emits: ["select"],
  methods: {
    scrollToSelected() {
      this.$nextTick(() => {
        const ref = this.$refs[`user-${this.selected}`];
        if (ref && ref[0]) {
          ref[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }
  }
};
</script>
